/* eslint-disable @typescript-eslint/no-magic-numbers */
import {
  IsArray,
  IsInt,
  IsNotEmpty,
  IsOptional,
  IsString,
  MaxLength,
} from "class-validator";

import "reflect-metadata";

export class RoleDto {
  id: number;

  @IsInt()
  @IsOptional()
  companyId?: number;

  @IsString()
  @MaxLength(255)
  @IsNotEmpty()
  name: string;

  @IsString()
  @IsOptional()
  @MaxLength(255)
  description?: string;

  @IsArray()
  @IsOptional()
  permissionIds?: number[];
}
